import type {ToolCallMessagePartComponent} from '@assistant-ui/react';
import React from 'react';

import {ErrorBoundary} from '../../../../components/ErrorBoundary';
import {createPreloadableLazyComponent} from '../../../../util/lazyImport';
import {selectActiveThread, useStoreSelector} from '../../../chat/store';
import type {AgentActionArgs} from '../../agentActionHandlers';

/** Backend tool name; mirrors the wandb_panel.py contract. */
export const WANDB_PANEL_TOOL_NAME = 'wbui__inchat_wandb_panel';
/** Kept only so persisted transcripts using the original name still render. */
export const LEGACY_INCHAT_PANEL_TOOL_NAME = 'wbui__inchat_panel';

const wandbPanel = createPreloadableLazyComponent(
  () => import('./WandbPanel'),
  module => module.WandbPanel
);
const LazyWandbPanel = wandbPanel.Component;

/** Load and render a live, read-only Reports panel grid for a W&B panel action. */
export const WandbPanelToolUI: ToolCallMessagePartComponent<
  AgentActionArgs
> = ({args, status}) => {
  const threadId = useStoreSelector(s => selectActiveThread(s)?.id ?? null);
  // Wait for streamed tool arguments to complete before rendering
  if (status.type === 'running') {
    return null;
  }
  return (
    <ErrorBoundary
      silent
      onError={error => {
        console.error('[WandbPanel] render crash', error);
      }}
      renderError={() => (
        <p className="my-8 text-sm text-wb-text-tertiary" role="alert">
          This chart could not be rendered.
        </p>
      )}>
      <React.Suspense fallback={null}>
        <LazyWandbPanel args={args} threadId={threadId} />
      </React.Suspense>
    </ErrorBoundary>
  );
};
